import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 店员业绩
 */
export const statisticsClerkOrder = (id, name, sex, isDisabled, startTime, endTime, pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'id',id)
    appendIfNotEmpty(data,'name',name)
    appendIfNotEmpty(data,'sex',sex)
    appendIfNotEmpty(data,'isDisabled',isDisabled)
    data.append('startTime',startTime)
    data.append('endTime',endTime)
    data.append('pageNo',pageNo)
    data.append('pageSize',pageSize)
    return axios.request({
        url: '/s/g/statistics/statisticsClerkOrder',
        data,
        method: 'post'
    })
}

/**
 * 获取订单详情
 */
export const getOrder = (id) => {
    return axios.request({
        url: '/s/g/order/get',
        params: {
            id
        },
        method: 'get'
    })
}
